import React, { useState, useEffect } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Avatar, Layout, Flex, Typography } from 'antd';
import { Outlet, useLocation, Navigate, useNavigate } from 'react-router-dom';
import MainHeader from '@/components/mainheader/index';
import MainFooter from '@/components/mainfooter/index';
import './index.scss';
import { useSelector } from 'react-redux';
import PersonalNavigation from '@/components/personalnavigation';
import AccountModerationNotice from '@/components/accountmoderationnotice';

const { Content, Sider } = Layout;
const { Text } = Typography;

const Personal = () => {
  // 配置初始化
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, userInfo } = useSelector(state => state.user);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
  const [showContent, setShowContent] = useState(true); // 控制移动端是否显示栏目页

  // 监听屏幕宽度变化，响应PC端和移动端样式
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 监听路由变化，控制 Content 显示
  useEffect(() => {
    // 只在移动端控制平移效果
    if (isMobile) {
      // 只要不是Personal页面就展示Outlet
      if (location.pathname !== '/personal') {
        setShowContent(true);
      } else {
        setShowContent(false);
      }
    } else {
      // PC端始终显示
      setShowContent(true);
    }
  }, [location, isMobile]);

  // 如果电脑端访问根路径，重定向到 /info，防止Outlet展示为空
  if (!isMobile && location.pathname === '/personal') {
    return <Navigate to="/personal/info" replace />;
  }

  return (
    <div className='personal'>
      <Layout>
        {/* 头部区域 */}
        <MainHeader />
        {/* 内容区域 */}
        <Layout>
          {/* 桌面侧栏由全局导航负责，移动端保留个人中心页面。 */}
          {isMobile && <Sider>
            {isAuthenticated ?
              // 已登录显示头像、用户名、个人页面栏目
              <Flex vertical className='personal-mobile-login-container'>
                <div className='personal-mobile-profile'>
                  <Avatar size={72} src={userInfo?.avatar || undefined} icon={<UserOutlined />} />
                  <div className='personal-mobile-profile-details'>
                    <strong className='personal-mobile-name'>{userInfo?.nickname || userInfo?.username || '用户'}</strong>
                    {userInfo?.nickname && userInfo?.username && userInfo.nickname !== userInfo.username && (
                      <span className='personal-mobile-username'>@{userInfo.username}</span>
                    )}
                    <span className='personal-mobile-uid'>UID <span>{userInfo?.id ?? '—'}</span></span>
                  </div>
                </div>
                {!showContent && <AccountModerationNotice />}
                <PersonalNavigation />
              </Flex> :
              // 未登录显示登录按钮
              <Flex vertical className='personal-mobile-waitinglogin-container'>
                <Flex justify='flex-start' align='center' onClick={() => navigate('/login', { replace: true })}>
                  <Avatar size='large' icon={<UserOutlined />} />
                  <Text className='personal-mobile-login-btn-text'>点击登录</Text>
                </Flex>
                <Text>登陆解锁更多内容</Text>
              </Flex>
            }
          </Sider>}
          {/* 个人栏目内容区域 */}
          <Content className={isMobile ? (showContent ? 'content-enter' : 'content-exit') : ''}>
            <div className='personal-content'>
              {/* 个人信息，帖子，修改密码展示处 */}
              <Outlet />
            </div>
          </Content>
        </Layout>
        {/* 底部区域 */}
        <MainFooter />
      </Layout>
    </div>
  );
};

export default Personal;
